/* dish prep image imports */
import pizzaPlate from "../../assets/games/picnic-game/pizza-prep/pizza-plate.png";
import pastaPan from "../../assets/games/picnic-game/pasta-prep/pasta-pan.png";
import burgerTray from "../../assets/games/picnic-game/burger-prep/burger-tray.png";
import smoothieJar from "../../assets/games/picnic-game/smoothie-prep/smoothie-jar.png";
import smoothiePreparing from "../../assets/games/picnic-game/smoothie-prep/smoothie-preparing.png";

/* ingredients image imports */
import alfredoSauce from "../../assets/games/picnic-game/dish-ingredients/alfredo-sauce.png";
import bacon from "../../assets/games/picnic-game/dish-ingredients/bacon.png";
import bellPepper from "../../assets/games/picnic-game/dish-ingredients/bell-pepper.png";
import berries from "../../assets/games/picnic-game/dish-ingredients/berries.png";
import blackBeanPatty from "../../assets/games/picnic-game/dish-ingredients/black-bean-patty.png";
import broccoli from "../../assets/games/picnic-game/dish-ingredients/broccoli.png";
import butter from "../../assets/games/picnic-game/dish-ingredients/butter.png";
import cheeseSlices from "../../assets/games/picnic-game/dish-ingredients/cheese-slices.png";
import chiaSeeds from "../../assets/games/picnic-game/dish-ingredients/chia-seeds.png";
import chocolateBars from "../../assets/games/picnic-game/dish-ingredients/chocolate-bars.png";
import creamyColeslaw from "../../assets/games/picnic-game/dish-ingredients/creamy-coleslaw.png";
import cutBrownies from "../../assets/games/picnic-game/dish-ingredients/cut-brownies.png";
import flaxSeeds from "../../assets/games/picnic-game/dish-ingredients/flax-seeds.png";
import freshFruits from "../../assets/games/picnic-game/dish-ingredients/fresh-fruits.png";
import friedFrenchFries from "../../assets/games/picnic-game/dish-ingredients/fried-french-fries.png";
import groundBeefPatty from "../../assets/games/picnic-game/dish-ingredients/ground-beef-patty.png";
import gummyBear from "../../assets/games/picnic-game/dish-ingredients/gummy-bear.png";
import heavyCheese from "../../assets/games/picnic-game/dish-ingredients/heavy-cheese.png";
import leanGrilledChicken from "../../assets/games/picnic-game/dish-ingredients/lean-grilled-chicken.png";
import lightCheese from "../../assets/games/picnic-game/dish-ingredients/light-cheese.png";
import lowFatPlainYogurt from "../../assets/games/picnic-game/dish-ingredients/low-fat-plain-yogurt.png";
import marinaraSauce from "../../assets/games/picnic-game/dish-ingredients/marinara-sauce.png";
import mayonnaise from "../../assets/games/picnic-game/dish-ingredients/mayonnaise.png";
import meatBalls from "../../assets/games/picnic-game/dish-ingredients/meat-balls.png";
import partSkimMozzarella from "../../assets/games/picnic-game/dish-ingredients/part-skim-mozzarella.png";
import pepperoni from "../../assets/games/picnic-game/dish-ingredients/pepperoni.png";
import porkSausages from "../../assets/games/picnic-game/dish-ingredients/pork-sausages.png";
import steamedVeggies from "../../assets/games/picnic-game/dish-ingredients/steamed-veggies.png";
import sugarFruitJuices from "../../assets/games/picnic-game/dish-ingredients/sugar-fruit-juices.png";
import sweetenedPlantMilk from "../../assets/games/picnic-game/dish-ingredients/sweetened-plant-milk.png";
import sweetPotatoFries from "../../assets/games/picnic-game/dish-ingredients/sweet-potato-fries.png";
import thickCrust from "../../assets/games/picnic-game/dish-ingredients/thick-crust.png";
import thinCrust from "../../assets/games/picnic-game/dish-ingredients/thin-crust.png";
import tomatoSauce from "../../assets/games/picnic-game/dish-ingredients/tomato-sauce.png";
import unsweetenedAlmondMilk from "../../assets/games/picnic-game/dish-ingredients/unsweetened-almond-milk.png";
import veggies from "../../assets/games/picnic-game/dish-ingredients/veggies.png";
import wafferBiscuits from "../../assets/games/picnic-game/dish-ingredients/waffer-biscuits.png";
import whippedCream from "../../assets/games/picnic-game/dish-ingredients/whipped-cream.png";
import whiteBun from "../../assets/games/picnic-game/dish-ingredients/white-bun.png";
import whitePasta from "../../assets/games/picnic-game/dish-ingredients/white-pasta.png";
import wholeWheatBun from "../../assets/games/picnic-game/dish-ingredients/whole-wheat-bun.png";
import wholeWheatPasta from "../../assets/games/picnic-game/dish-ingredients/whole-wheat-pasta.png";

/* pizza prep image imports */
import bellPepperPizzaPrep from "../../assets/games/picnic-game/pizza-prep/bell-pepper.png";
import broccoliPizzaPrep from "../../assets/games/picnic-game/pizza-prep/broccoli.png";
import lightCheesePizzaPrep from "../../assets/games/picnic-game/pizza-prep/light-cheese.png";
import heavyCheesePizzaPrep from "../../assets/games/picnic-game/pizza-prep/heavy-cheese.png";
import gummyBearPizzaPrep from "../../assets/games/picnic-game/pizza-prep/gummy-bear.png";
import alfredoSaucePizzaPrep from "../../assets/games/picnic-game/pizza-prep/alfredo-sauce.png";
import pepperoniPizzaPrep from "../../assets/games/picnic-game/pizza-prep/pepperoni.png";
import baconPizzaPrep from "../../assets/games/picnic-game/pizza-prep/bacon.png";
import thickCrustPizzaPrep from "../../assets/games/picnic-game/pizza-prep/thick-crust.png";
import thinCrustPizzaPrep from "../../assets/games/picnic-game/pizza-prep/thin-crust.png";
import leanGrilledChickenPizzaPrep from "../../assets/games/picnic-game/pizza-prep/lean-grilled-chicken.png";
import tomatoSaucePizzaPrep from "../../assets/games/picnic-game/pizza-prep/tomato-sauce.png";
import pizzaPrepared from "../../assets/games/picnic-game/pizza-prep/pizza-prepared.png";

/* pasta prep image imports */

import alfredoSaucePastaPrep from "../../assets/games/picnic-game/pasta-prep/alfredo-sauce.png";
import bellPepperPastaPrep from "../../assets/games/picnic-game/pasta-prep/bell-pepper.png";
import broccoliPastaPrep from "../../assets/games/picnic-game/pasta-prep/broccoli.png";
import butterPastaPrep from "../../assets/games/picnic-game/pasta-prep/butter.png";
import heavyCheesePastaPrep from "../../assets/games/picnic-game/pasta-prep/heavy-cheese.png";
import leanGrilledChickenPastaPrep from "../../assets/games/picnic-game/pasta-prep/lean-grilled-chicken.png";
import lightCheesePastaPrep from "../../assets/games/picnic-game/pasta-prep/light-cheese.png";
import marinaraSaucePastaPrep from "../../assets/games/picnic-game/pasta-prep/marinara-sauce.png";
import meatBallsPastaPrep from "../../assets/games/picnic-game/pasta-prep/meat-balls.png";
import porkSausagesPastaPrep from "../../assets/games/picnic-game/pasta-prep/pork-sausages.png";
import whitePastaPastaPrep from "../../assets/games/picnic-game/pasta-prep/white-pasta.png";
import wholeWheatPastaPastaPrep from "../../assets/games/picnic-game/pasta-prep/whole-wheat-pasta.png";
import pastaPrepared from "../../assets/games/picnic-game/pasta-prep/pasta-prepared.png";

/* burger prep image imports */

import blackBeanPattyBurgerPrep from "../../assets/games/picnic-game/burger-prep/black-bean-patty.png";
import cheeseSlicesBurgerPrep from "../../assets/games/picnic-game/burger-prep/cheese-slices.png";
import creamyColeslawBurgerPrep from "../../assets/games/picnic-game/burger-prep/creamy-coleslaw.png";
import freshFruitsBurgerPrep from "../../assets/games/picnic-game/burger-prep/fresh-fruits.png";
import friedFrenchFriesBurgerPrep from "../../assets/games/picnic-game/burger-prep/fried-french-fries.png";
import groundBeefPattyBurgerPrep from "../../assets/games/picnic-game/burger-prep/ground-beef-patty.png";
import mayonnaiseBurgerPrep from "../../assets/games/picnic-game/burger-prep/mayonnaise.png";
import partSkimMozzarellaBurgerPrep from "../../assets/games/picnic-game/burger-prep/part-skim-mozzarella.png";
import steamedVeggiesBurgerPrep from "../../assets/games/picnic-game/burger-prep/steamed-veggies.png";
import sweetPotatoFriesBurgerPrep from "../../assets/games/picnic-game/burger-prep/sweet-potato-fries.png";
import whiteBunBurgerPrep from "../../assets/games/picnic-game/burger-prep/white-bun.png";
import wholeWheatBunBurgerPrep from "../../assets/games/picnic-game/burger-prep/whole-wheat-bun.png";
import burgerPrepared from "../../assets/games/picnic-game/burger-prep/burger-prepared.png";

/* smoothie prep image imports */

import berriesSmoothiePrep from "../../assets/games/picnic-game/smoothie-prep/berries.png";
import chiaSeedsSmoothiePrep from "../../assets/games/picnic-game/smoothie-prep/chia-seeds.png";
import chocolateBarsSmoothiePrep from "../../assets/games/picnic-game/smoothie-prep/chocolate-bars.png";
import cutBrowniesSmoothiePrep from "../../assets/games/picnic-game/smoothie-prep/cut-brownies.png";
import flaxSeedsSmoothiePrep from "../../assets/games/picnic-game/smoothie-prep/flax-seeds.png";
import lowFatPlainYogurtSmoothiePrep from "../../assets/games/picnic-game/smoothie-prep/low-fat-plain-yogurt.png";
import sugarFruitJuicesSmoothiePrep from "../../assets/games/picnic-game/smoothie-prep/sugar-fruit-juices.png";
import sweetenedPlantMilkSmoothiePrep from "../../assets/games/picnic-game/smoothie-prep/sweetened-plant-milk.png";
import unsweetenedAlmondMilkSmoothiePrep from "../../assets/games/picnic-game/smoothie-prep/unsweetened-almond-milk.png";
import veggiesSmoothiePrep from "../../assets/games/picnic-game/smoothie-prep/veggies.png";
import wafferBiscuitsSmoothiePrep from "../../assets/games/picnic-game/smoothie-prep/waffer-biscuits.png";
import whippedCreamSmoothiePrep from "../../assets/games/picnic-game/smoothie-prep/whipped-cream.png";
import smoothiePrepared from "../../assets/games/picnic-game/smoothie-prep/smoothie-prepared.png";

/* ingredients image export */

export const dishIngredientsImagesObj = {
  alfredoSauce,
  bacon,
  bellPepper,
  berries,
  blackBeanPatty,
  broccoli,
  butter,
  cheeseSlices,
  chiaSeeds,
  chocolateBars,
  creamyColeslaw,
  cutBrownies,
  flaxSeeds,
  freshFruits,
  friedFrenchFries,
  groundBeefPatty,
  gummyBear,
  heavyCheese,
  leanGrilledChicken,
  lightCheese,
  lowFatPlainYogurt,
  marinaraSauce,
  mayonnaise,
  meatBalls,
  partSkimMozzarella,
  pepperoni,
  porkSausages,
  steamedVeggies,
  sugarFruitJuices,
  sweetenedPlantMilk,
  sweetPotatoFries,
  thickCrust,
  thinCrust,
  tomatoSauce,
  unsweetenedAlmondMilk,
  veggies,
  wafferBiscuits,
  whippedCream,
  whiteBun,
  whitePasta,
  wholeWheatBun,
  wholeWheatPasta,
};

/* pizza prep image export */

export const pizzaPrepImagesObj = {
  pizzaPlate,
  bellPepperPizzaPrep,
  broccoliPizzaPrep,
  lightCheesePizzaPrep,
  heavyCheesePizzaPrep,
  gummyBearPizzaPrep,
  alfredoSaucePizzaPrep,
  pepperoniPizzaPrep,
  baconPizzaPrep,
  thickCrustPizzaPrep,
  thinCrustPizzaPrep,
  leanGrilledChickenPizzaPrep,
  tomatoSaucePizzaPrep,
  pizzaPrepared,
};

/* pasta prep image export */

export const pastaPrepImagesObj = {
  pastaPan,
  alfredoSaucePastaPrep,
  bellPepperPastaPrep,
  broccoliPastaPrep,
  butterPastaPrep,
  heavyCheesePastaPrep,
  leanGrilledChickenPastaPrep,
  lightCheesePastaPrep,
  marinaraSaucePastaPrep,
  meatBallsPastaPrep,
  porkSausagesPastaPrep,
  whitePastaPastaPrep,
  wholeWheatPastaPastaPrep,
  pastaPrepared,
};

/* burger prep image export */

export const burgerPrepImagesObj = {
  burgerTray,
  blackBeanPattyBurgerPrep,
  cheeseSlicesBurgerPrep,
  creamyColeslawBurgerPrep,
  freshFruitsBurgerPrep,
  friedFrenchFriesBurgerPrep,
  groundBeefPattyBurgerPrep,
  mayonnaiseBurgerPrep,
  partSkimMozzarellaBurgerPrep,
  steamedVeggiesBurgerPrep,
  sweetPotatoFriesBurgerPrep,
  whiteBunBurgerPrep,
  wholeWheatBunBurgerPrep,
  burgerPrepared,
};

/* smoothie prep image export */

export const smoothiePrepImagesObj = {
  smoothieJar,
  smoothiePreparing,
  berriesSmoothiePrep,
  chiaSeedsSmoothiePrep,
  chocolateBarsSmoothiePrep,
  cutBrowniesSmoothiePrep,
  flaxSeedsSmoothiePrep,
  lowFatPlainYogurtSmoothiePrep,
  sugarFruitJuicesSmoothiePrep,
  sweetenedPlantMilkSmoothiePrep,
  unsweetenedAlmondMilkSmoothiePrep,
  veggiesSmoothiePrep,
  wafferBiscuitsSmoothiePrep,
  whippedCreamSmoothiePrep,
  smoothiePrepared,
};
